<template>
    <div class="commentsContainer">
        <ul class="annotationsList">
            <li class="annotationsGroup" v-for="item in list" :key="item.id">
                <annotations-list-item
                    :item="item"
                    :data="data"
                    @delete="deleteAnnotation"
                    :corptype="corptype"
                    />
            </li>
        </ul>
    </div>
</template>

<script>
    import AnnotationsListItem from "vcomponents/utilities/AnnotationsListItem.vue"
    export default {
        props: {
            list:{
                type: Array,
                required: false,
                default: () => []
            },
            data: {
                type: Object,
                required: false,
                default: () => {}
            },
            corptype: {
                type: String,
                required: false,
                default: ''
            },
        },
        methods: {
            deleteAnnotation(payload){
                this.$emit('delete', payload)
            }
        },
        components: {
            AnnotationsListItem
        }
    }
</script>